import { render, staticRenderFns } from "./InvitationCodeForm.vue?vue&type=template&id=05888978&"
import script from "./InvitationCodeForm.vue?vue&type=script&lang=ts&"
export * from "./InvitationCodeForm.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationCodeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports